"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";
type CartDrawerContextValue = {
  isOpen: boolean;
  recentItem: RecentItem | null;
  open: (item?: RecentItem | null) => void;
  close: () => void;
};
type RecentItem = {
  title?: string;
  image?: string | null;
  variantLabel?: string;
  quantity?: number;
};
const CartDrawerContext = createContext<CartDrawerContextValue | undefined>(undefined);
export const CartDrawerProvider = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [recentItem, setRecentItem] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = item => {
      if (item) {
        setRecentItem(item);
      }
      setIsOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const open = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsOpen(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const close = t2;
  let t3;
  if ($[2] !== isOpen || $[3] !== recentItem) {
    t3 = {
      isOpen,
      recentItem,
      open,
      close
    };
    $[2] = isOpen;
    $[3] = recentItem;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const value = t3;
  let t4;
  if ($[5] !== children || $[6] !== value) {
    t4 = <CartDrawerContext.Provider value={value}>{children}</CartDrawerContext.Provider>;
    $[5] = children;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export const useCartDrawer = () => {
  const context = useContext(CartDrawerContext);
  if (!context) {
    throw new Error("useCartDrawer must be used within a CartDrawerProvider");
  }
  return context;
};
export type { RecentItem as CartDrawerRecentItem };